'use strict';

import SweetScroll from "sweet-scroll";

var $ = require("jquery");
window.jQuery = $;
require("@fancyapps/fancybox");

document.addEventListener("DOMContentLoaded", () => {
  const sweetScroll = new SweetScroll({
    updateURL: "replace"
  });
  modal();

  const ua = navigator.userAgent.toLowerCase();
  if ((ua.indexOf('iphone') > 0 && ua.indexOf( 'ipad') == -1) || ua.indexOf('ipod') > 0 || ua.indexOf('android') > 0) {
    document.body.classList.add("sp");
  }

  const portrait = window.matchMedia("(orientation: portrait)").matches;
  const landscape = window.matchMedia("(orientation: landscape)").matches;
  if (portrait) {
    document.body.classList.add("portrait");
  } else {
    document.body.classList.add("lancscape");
  }
}, false);

$(function(){
  $("#story").find(".word").on("click", function () {
    $("#modal").addClass("open");
  });
  $("#modal").on("click", function(){
    $(this).removeClass("open");
  });
});

function modal() {
  if (document.getElementById("autoModal") !== null){
    document.getElementsByClassName("modalLink")[0].click();
  }
}

let voice = {
  flag: {},
  currentTime: null
};

$(function(){
  const setClass = 'voiceItem';
  const setDir = 'voice/';
  const sounds = document.getElementsByClassName(setClass);

  for (let i = 0, l = sounds.length; l > i; i++) {
    sounds[i].onclick = function () {
      const file = this.getAttribute('data-voice');

      if (typeof(voice.flag[file]) == "undefined" || voice.flag[file] != 1) {
        let audio = document.createElement('audio');

        audio.id = file;
        audio.src = setDir + file + '.mp3';
        document.body.appendChild(audio);
      }

      stopCurrentSound();
      document.getElementById(file).play();
      voice.currentTime = file;
      voice.flag[file] = 1;
      return false;
    }
  }

  // 前回の音声を停止する関数
  function stopCurrentSound() {
    let currentSound = document.getElementById(voice.currentTime);

    if (currentSound != null) {
      currentSound.pause();
      currentSound.currentTime = 0;
    }
  }
});



// WEBPACK FOOTER //
// ./src/js/script.js